//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        website: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            newHeroSlide: {
                image: null,
                sectionTitle: 'New hero slide',
                subtitle: '',
                btn_1_text: '',
                btn_2_text: '',
                video_url: '',
                form: null,
                toggleMediaGallery: false
            },
            hero: [{
                image: null,
                sectionTitle: 'Hero 1 - Sample',
                subTitle: ''
            }],
            intro: {
                introText: '',
                image: null
            },
            featured: {
                image: null,
                url: null
            },
            footerGallery: {
                image: null,
                url: null
            },
            featuredImages: {},
            gallery: {
                showGallery: true,
                galleryType: 'full'
            },
            showFullGallery: false
        };
    },
    mounted: function mounted() {
        Event.$on('save-page-home', function () {
            $el.refresh();
        });

        if (this.website) {

            if (this.website.floorplans_show_full_gallery == 1) {
                this.showFullGallery = true;
            } else {
                this.showFullGallery = false;
            }
        }
    },

    methods: {
        deploySite: function deploySite() {
            Event.$emit('deploy-site');
        },
        savePageFloorplans: function savePageFloorplans() {
            var _this = this;

            var $el = this;
            var fd = new FormData();

            fd.append('floorplan_data', 1);
            fd.append('floorplans_hero_headline', $el.website.floorplans_hero_headline);
            fd.append('floorplans_hero_byline', $el.website.floorplans_hero_byline);
            fd.append('floorplans_hero_video_url', $el.website.floorplans_hero_video_url);
            fd.append('floorplans_intro_text', $el.website.floorplans_intro_text);
            fd.append('floorplans_has_asmartment', 0);
            if ($el.website.floorplans_has_asmartment || $el.website.floorplans_has_asmartment == 'true') {
                fd.append('floorplans_has_asmartment', 1);
            }
            fd.append('floorplans_show_full_gallery', 0);
            if ($el.showFullGallery) {
                fd.append('floorplans_show_full_gallery', 1);
            }
            fd.append('floorplans_page_gallery_type', $el.website.floorplans_page_gallery_type);
            fd.append('floorplans_gallery_left_label', $el.website.floorplans_gallery_left_label);
            fd.append('floorplans_gallery_right_label', $el.website.floorplans_gallery_right_label);

            var gallery = $el.website.floorplans_hero_image_gallery.photos;
            if (gallery.length) {
                for (var i = 0; i < gallery.length; i++) {
                    fd.append('gallery[floorplans_hero_images][' + i + '][id]', gallery[i].id);
                    fd.append('gallery[floorplans_hero_images][' + i + '][image]', gallery[i].image);
                    fd.append('gallery[floorplans_hero_images][' + i + '][main_title]', gallery[i].meta.main_title);
                    fd.append('gallery[floorplans_hero_images][' + i + '][subtitle]', gallery[i].meta.subtitle);
                }
            }

            var gallery = $el.website.floorplans_featured_image_gallery.photos;
            if (gallery.length) {
                for (var i = 0; i < gallery.length; i++) {
                    fd.append('gallery[floorplans_featured_images][' + i + '][id]', gallery[i].id);
                    fd.append('gallery[floorplans_featured_images][' + i + '][image]', gallery[i].image);
                    fd.append('gallery[floorplans_featured_images][' + i + '][description]', gallery[i].meta.description);
                }
            }

            console.log('floorplans SUBMIT, fd below:');
            console.log(fd);

            axios.post('/prototype/website/' + $el.website.id, fd).then(function (response) {
                if (response.data.error) {
                    _this.$snotify.error('Error saving website data: ' + response.data.error);
                } else {
                    _this.$snotify.success('Website data was updated');
                    Event.$emit('refresh-property-website', $el.website.property_id);
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/pages/PageFloorplans.vue
// module id = VO3/
// module chunks = 0 1